import React from 'react';
import { UsageBehaviorSettings } from './UsageBehaviorSettings';
import { CacheManagement } from './CacheManagement';
import type { DevSettings } from '../../../utils/storage';
import type { MigrationStatus } from '../../../utils/cache-migration';
import type { IndexedDBCache } from '../../../utils/indexeddb-cache';

interface ApplicationSectionProps {
  isActive: boolean;
  devSettings: DevSettings;
  notificationThreshold: number;
  onDevSettingsChange: (newSettings: Partial<DevSettings>) => void;
  onResetDevSettings: () => void;
  onThresholdChange: (value: number) => void;

  cacheStats: Awaited<ReturnType<IndexedDBCache['getStats']>> | null;
  migrationStatus: MigrationStatus | null;
  isMigrating: boolean;
  onMigration: () => void;
  onClearExpired: () => void;
  onClearAll: () => void;
  onClearServiceCache: (service: 'openai' | 'anthropic' | 'gemini' | 'github') => void;
  onRefreshStats: () => void;
  formatBytes: (bytes: number) => string;
}

export const ApplicationSection: React.FC<ApplicationSectionProps> = ({
  isActive,
  devSettings,
  notificationThreshold,
  onDevSettingsChange,
  onResetDevSettings,
  onThresholdChange,
  cacheStats,
  migrationStatus,
  isMigrating,
  onMigration,
  onClearExpired,
  onClearAll,
  onClearServiceCache,
  onRefreshStats,
  formatBytes
}) => {
  return (
    <section className={isActive ? 'space-y-3' : 'hidden'}>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
        <UsageBehaviorSettings
          devSettings={devSettings}
          notificationThreshold={notificationThreshold}
          onDevSettingsChange={onDevSettingsChange}
          onResetDevSettings={onResetDevSettings}
          onThresholdChange={onThresholdChange}
        />
        <CacheManagement
          cacheStats={cacheStats}
          migrationStatus={migrationStatus}
          isMigrating={isMigrating}
          onMigration={onMigration}
          onClearExpired={onClearExpired}
          onClearAll={onClearAll}
          onClearServiceCache={onClearServiceCache}
          onRefreshStats={onRefreshStats}
          formatBytes={formatBytes}
        />
      </div>
    </section>
  );
};
